export default __webpack_public_path__ + "static/media/fire.7fdf203d.svg";